<template>
  <Appendix
    title="Biên bản chuyển nhượng"
    :fields="fieldsTable"
    :actions="actions"
    :excepts="excepts"
    :only="only"
    :items="items"
    :contract="contract"
  >
    <template #row-details="item">
      <DeviceInfoAppendix :items="item.appendixTransfer.deviceTransfers" :fields="deviceFields" />
    </template>
    <template #file="item">
      <div v-if="item.urlPDF" class="form-detail">
        <UploadMultiple
          :lsData="[item]"
          keyUrl="urlPDF"
          :canUpload="false"
          :title="`File biên bản ${item.code}`"
          titleTag="h1"
          titleClass="form-inner-heading"
        />
      </div>
    </template>
  </Appendix>
</template>
<script>
  import Appendix from './Appendix.vue'
  import DeviceInfoAppendix from './DeviceInfoAppendix.vue'
  import UploadMultiple from '@/components/UploadMultiple.vue'
  export default {
    props: {
      actions: {
        type: Function,
      },
      excepts: {
        type: Array,
        default: () => [],
      },
      only: {
        type: Array,
        default: () => [],
      },
      items: {
        type: Array,
        default: () => [],
      },
      contract: {
        type: Object,
        default: () => {},
      },
    },
    components: { Appendix, DeviceInfoAppendix, UploadMultiple },
    data() {
      return {
        fieldsTable: [
          { key: 'code', label: 'Mã biên bản', class: 'text-left' },
          {
            key: 'time',
            label: 'Thời gian',
            class: 'text-left',
            thStyle: 'min-width: 210px',
          },
          {
            key: 'appendixTransfer.merchantName',
            label: 'MC nhận chuyển nhượng',
            class: 'text-left',
          },
          {
            key: 'appendixTransfer.deviceTransfers.length',
            label: 'SL thiết bị',
            class: 'text-right',
          },
          { key: 'state', label: 'Trạng thái', class: 'text-center' },
          { key: 'action', label: 'Thao tác', class: 'text-center' },
        ],
        deviceFields: [
          {
            key: 'displayName',
            label: 'Tên thiết bị',
            class: 'text-left',
            formatter: (v, k, item) => item.device.name ?? item.device.displayName,
          },
          { key: 'device.serialNumber', label: 'Mã serial', class: 'text-left' },
          {
            key: 'deviceState',
            label: 'Tình trạng sử dụng',
            class: 'text-center',
            formatter: (v, k, item) => item.status ?? item.deviceState,
          },
        ],
      }
    },
  }
</script>

<style scoped></style>
